import {Component, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {IDialogComponent} from "../../../../../common/dialog/iDialog.component";
import {DialogWithInput} from "../../../../../common/dialog/dialogWithInput";
import {DialogModule} from "../../../../../common/dialog/dialog.module";
import {DocumentSignComponent} from "../document-sign/document-sign.component";
import {ButtonModule} from "../../../../../core/component/button/button.module";

export interface DocumentSignDialogInput {
  documentId: number;
}

export interface DocumentSignDialogOutput {
  signed: boolean;
}

@Component({
  selector: 'app-document-sign-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, DocumentSignComponent, ButtonModule],
  templateUrl: './document-sign-dialog.component.html',
})
export class DocumentSignDialogComponent implements IDialogComponent<DocumentSignDialogInput, DocumentSignDialogOutput>{
  dialog: DialogWithInput<DocumentSignDialogInput, DocumentSignDialogOutput>;

  @ViewChild('signComponent') signComponent: DocumentSignComponent;

  signed() {
    this.dialog.close({
      signed: true
    });
  }
}
